import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { createCourse } from '../../../services/api';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function CoursesCreate() {
  const [title, setTitle] = useState('');
  const [license, setLicense] = useState('private');
  const [isPublic, setIsPublic] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (title.trim() === '') {
      setError('Course Name is required.');
      toast.error('Course Name is required.');
      return;
    }

    setError('');

    const courseData = {
      title,
      license,
      isPublic,
    };

    try {
      await createCourse(courseData);
      toast.success('Course created successfully!');
      setTimeout(() => navigate('/dashboard/courses'), 1500); // Delay redirect slightly for UX
    } catch (err) {
      console.error(err);
      toast.error('Error creating the course.');
    }
  };

  return (
    <>
      <div className="row pt-2 pb-2">
        <div className="col-sm-9">
          <h4 className="page-title">Start a New Course</h4>
        </div>
        <div className="col-sm-3">
          <div className="btn-group float-sm-right">
            <Link
              to="/dashboard/courses"
              className="btn btn-outline-primary waves-effect waves-light"
            >
              <i className="ti-back-left"></i> Cancel
            </Link>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-3"></div>
        <div className="col-lg-6">
          <div className="card">
            <div className="card-body">
              <form className="form-bordered" onSubmit={handleSubmit}>
                <div className="form-group row">
                  <label htmlFor="course-name" className="col-sm-3 col-form-label">Course Name</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      id="course-name"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                      required
                    />
                    {error && <div className="text-danger">{error}</div>}
                  </div>
                </div>

                <div className="form-group row">
                  <label htmlFor="content-license" className="col-sm-3 col-form-label">Content License</label>
                  <div className="col-sm-9">
                    <select
                      className="custom-select"
                      id="content-license"
                      value={license}
                      onChange={(e) => setLicense(e.target.value)}
                    >
                      <option value="private">Private (Copyrighted)</option>
                      <option value="public">Public Domain</option>
                      <optgroup label="Creative Commons Licenses">
                        <option value="cc-by">CC Attribution</option>
                        <option value="cc-by-sa">CC Attribution ShareAlike</option>
                        <option value="cc-by-nd">CC Attribution NoDerivatives</option>
                        <option value="cc-by-nc">CC Attribution NonCommercial</option>
                        <option value="cc-by-nc-sa">CC Attribution NonCommercial ShareAlike</option>
                        <option value="cc-by-nc-nd">CC Attribution NonCommercial NoDerivatives</option>
                      </optgroup>
                    </select>
                  </div>
                </div>

                <div className="form-group row">
                  <label htmlFor="visibility" className="col-sm-3 col-form-label"></label>
                  <div className="col-sm-9">
                    <input
                      type="checkbox"
                      id="visibility"
                      checked={isPublic}
                      onChange={(e) => setIsPublic(e.target.checked)}
                    />
                    <label htmlFor="visibility">Make course publicly visible (Student data will remain private)</label>
                  </div>
                </div>

                <div className="form-footer-new">
                  <Link to="/dashboard/courses" className="btn btn-danger danger m-1">
                    <i className="fa fa-times"></i> CANCEL
                  </Link>
                  <button type="submit" className="btn btn-success success m-1">
                    <i className="fa fa-check-square-o"></i> SAVE
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default CoursesCreate;
